<template>
  <v-dialog v-model="dialog.show" persistent max-width="900">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="table.selected"
          :search="table.search"
          :headers="table.headers"
          :items="table.dados"
          :single-select="false"
          item-key="cpf_completo"
          show-select
          @item-selected="itemSelecionado"
          :items-per-page="8"
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="reset()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Colaborador from "@/services/colaborador";
import Equipe from "@/services/equipe";
export default {
  data() {
    return {
      dialog: {
        show: false,
        title: "Editar Equipe"
      },
      ctrl: false,
      table: {
        selected: [],
        search: "",
        headers: [
          { text: "Nome", value: "colaborador" },
          { text: "Cpf", value: "cpf_completo" }
        ],
        dados: []
      },
      equipeSelecionada: null,
      equipes: null,
      colaboradores: []
    };
  },
  methods: {
    async show(equipeSelecionada, equipes) {

      this.equipes = equipes;
      this.equipeSelecionada = equipeSelecionada;
      this.dialog.show = true;
      try {
        await this.loadColaboradores(this.equipeSelecionada.cnpj);
        this.loadEquipe();
      } catch (error) {
        console.error(error);
      }
    },
    reset() {
      this.equipes = null;
      this.equipeSelecionada = null;
      this.dialog.show = false;
      this.table.selected = [];
      this.table.dados = [];
      this.colaboradores = [];
      this.ctrl = false;
    },
    loadEquipe() {
      // this.table.dados.push(...this.equipeSelecionada.colaboradores);
      this.table.selected.push(...this.equipeSelecionada.colaboradores);
      this.table.dados.push(...this.colaboradores);
    },
    async loadColaboradores(cnpj) {
      try {
        let Colaboradores = await new Colaborador().getByEmpresas([cnpj]);

        for (let col of Colaboradores) {
          this.colaboradores.push({
            ativo: col.ativo ? "S" : "N",
            colaborador: col.nome,
            cpf_completo: col.cpf,
            funcao: col.funcao,
            id_funcao_nivel: 0,
            nivel: col.papel,
            situacao: "D"
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async updateEquipe(
      equipe,
      codigoEquipe,
      cnpj,
      ColaboradoresNovos,
      ColaboradoresAntigos
    ) {
      try {
        await new Equipe().updateEquipe(
          equipe,
          cnpj,
          codigoEquipe,
          ColaboradoresNovos,
          ColaboradoresAntigos
        );
      } catch (error) {
        console.error(error);
      }
    },
    itemSelecionado(item) {
      var colaborador = item.item ? item.item : item;

      const ColaboradoresAntigos = [];
      if (this.equipes !== null) {
        let equipes = [...this.equipes];
        equipes.forEach(element => {
          element.colaboradores.forEach(colab => {
            if (colab.cpf_completo === colaborador.cpf_completo) {
              this.$swal
                .confirm(
                  "Equipe Antiga :<h4><b>" + element.nome,
                  "<b></h4>Deseja mudar a Equipe desse Colaborador?"
                )
                .then(async () => {
                  ColaboradoresAntigos.push(...colab.colaboradores);

                  var index = colab.colaboradores.indexOf(colab);

                  if (index > -1) {
                    col.colaboradores.splice(index, 1);
                  }
                  let ColaboradoresNovos = colab.colaboradores;

                  // await this.updateEquipe(
                  //   col,
                  //   col.codigoEquipe,
                  //   this.empresas,
                  //   ColaboradoresNovos,
                  //   ColaboradoresAntigos
                  // );
                })
                .catch(e => this.table.selected.pop());
            }
          });
        });
      }
    }
  }
};
</script>

<style>
</style>
